import { TASKS, ROLES, DEPARTMENTS, USERS } from "../config";
import { get, post } from "./apiHelper";

const buildQuery = (params = {}) => {
  const q = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null && v !== "")
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join("&");
  return q ? `?${q}` : "";
};

export const fetchTasks = (params = {}) =>
  get(`${TASKS}${buildQuery(params)}`, { noCache: true });

export const fetchTaskSummary = () =>
  get(`${TASKS}/summary`, { noCache: true });

export const createTask = (task) => post(`${TASKS}/create`, task);

export const updateTask = (id, task) => post(`${TASKS}/update/${id}`, task);

export const deleteTask = (id) => post(`${TASKS}/delete/${id}`);

export const remindTask = (id, assigneeId) =>
  post(`${TASKS}/${id}/remind`, { user_id: assigneeId });

export const fetchRoles = () => get(ROLES, { noCache: true });

export const fetchDepartments = () => get(DEPARTMENTS, { noCache: true });

export const fetchUsers = (params = { count: 100 }) =>
  get(`${USERS}${buildQuery(params)}`, { noCache: true });
